import { ref } from 'vue'
import { type Ref } from 'vue'
import type { Api, ReqAfter, ReqBefore, Method } from '@el-plus/utils/http'
import type { Canceler } from 'axios'
import axios from 'axios'
import { http } from '@el-plus/utils/http'
type UseRequest = (config: {
  api?: Api
  method?: Method
  reqData?: Record<string, unknown>
  reqParams?: Record<string, unknown>
  reqBefore?: ReqBefore
  reqAfter?: ReqAfter
  cancelToken?: boolean
  hooks?: {
    success?: (data: unknown) => void
    fail?: (error: unknown) => void
  }
}) => {
  loading?: Ref<boolean>
  requestFn?: (data?: Record<string, unknown>) => Promise<void>
}

export const useRequest: UseRequest = ({
  api,
  method = 'post',
  reqData,
  reqParams,
  reqBefore,
  reqAfter,
  cancelToken,
  hooks,
}) => {
  if (!api) return {}
  const loading = ref(false)
  let cancelRequest: Canceler
  let apiFn
  if (typeof api === 'string') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const config: Record<string, any> = {
      method,
    }
    apiFn = (data: Record<string, any> = {}, params?: Record<string, any>) => {
      if (config.method === 'get') {
        config.params = data
      } else {
        config.data = data
        config.params = params
      }
      config.data = {
        ...reqData,
        ...config.data,
      }
      config.params = {
        ...reqParams,
        ...config.params,
      }
      // 替换$query为$searchValue
      if (config.data.$query) {
        config.data[config.data.$query] = data.$searchValue
        delete config.data.$searchValue
        delete config.data.$query
      }

      if (reqBefore) {
        reqBefore(config)
      }
      if (cancelToken) {
        config.cancelToken = new axios.CancelToken(function (cancel) {
          cancelRequest = cancel
        })
      }
      return http.request(api, config)
    }
  } else {
    apiFn = api
  }
  const requestFn = async (data: Record<string, unknown> = {}, params?: Record<string, unknown>) => {
    if (loading.value && !cancelToken) return
    loading.value = true
    try {
      cancelRequest && cancelRequest()
      const res = await apiFn(data, params)
      // 如果api是函数,直接追加success,data
      if (reqAfter) {
        reqAfter(res)
      }
      if (hooks?.success) {
        hooks.success(typeof api === 'function' ? res : res.data)
      }
      loading.value = false

    } catch (error) {
      if (hooks?.fail) {
        hooks.fail(error)
      }
      if(axios.isCancel(error)){
        return
      }
      loading.value = false
    } finally {
    }
  }
  return {
    loading,
    requestFn,
  }
}
